export const ratingColorList = {
    "0": "#fff",
    "1": "#AFE669",
    "2": "#FFDC1B",
    "3": "#FFA17E",
    "4": "#FA5C5C"
};